module.exports = __webpack_public_path__ + "img/mobelnetworktest1.09607b7.png";